import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MedicalFeeControlSearchItem } from '../../../model/medical-fee/medical-fee-control-search-item';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { MedicalFeePaymentWizardService } from '../../../services/medical-fee/medical-fee-payment-wizard.service';

@Component({
  selector: 'app-medical-fee-payment-detail',
  templateUrl: './medical-fee-payment-detail.component.html',
  styleUrls: ['./medical-fee-payment-detail.component.css']
})
export class MedicalFeePaymentDetailComponent implements OnInit {

  @ViewChild('pager', {static: true}) pager: PagerControlComponent;
  @Output() removed = new EventEmitter<MedicalFeeControlSearchItem[]>();

  selection = new SelectionModel<MedicalFeeControlSearchItem>(true, []);
  dataSource = new MatTableDataSource<MedicalFeeControlSearchItem>([]);
  loading: boolean;
  loadingAction: boolean;

  displayedColumns: string[] = [
                  'Select', 'Date', 'PatientFullName', 'Protocol',
                  'PracticeName', 'MedicalFeeAmount', 'Amount'
                ];

  constructor( private mfpWizardService: MedicalFeePaymentWizardService ) { }

  ngOnInit() {

    this.selection = new SelectionModel<MedicalFeeControlSearchItem>(true, []);
    this.pager.setItems(this.mfpWizardService.getMedicalFeeControlSearchItems());
  }

  masterToggle() {

    this.isAllSelected() ?
        this.selection.clear() :
        this.pager.getAllItems().forEach(row => this.selection.select(row));
  }

  isAllSelected() {

    if (this.selection.selected && this.pager.getAllItems()) {
      const numSelected = this.selection.selected.length;
      const numRows = this.pager.getAllItems().length;
      return numSelected === numRows;
    } else {
      return false;
    }
  }

  selectedPageIndexChange(pagedItems: any[]) {

    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  async excludeCero() {

     const items = this.dataSource.data.filter( d => d.MedicalFeeAmount === 0);
      if ( items && items.length > 0 ) {
        await this.removeItems(items);
      }
  }

  async excludeSelected() {

    const items = this.selection.selected;
    if ( items && items.length > 0 ) {
      await this.removeItems(items);
    }
  }

  private async removeItems(items: MedicalFeeControlSearchItem[]) {

    await this.mfpWizardService.removeMedicalFeeControlSearchItems(items);
    this.pager.setItems(this.mfpWizardService.getMedicalFeeControlSearchItems());
    this.selection.clear();
    this.removed.emit(items);
  }
}
